import React from "react";
import ChordParser, { ParsedChord } from "../../utils/ChordParser";
import parsedChordTransposer from "../../utils/ParsedChordTransposer";

interface ChordProps {
  transpose_to: string;
  chart_key: string;
  beat_text: string;
  scalePercent?: number;
}

const BEAT_WIDTHS = { min: 20, max: 70 };

function ChordComponent({ transpose_to, chart_key, beat_text, scalePercent }: ChordProps) {
  const orig_parsed: ParsedChord = new ChordParser(beat_text).parsed;
  const chord_parsed: ParsedChord = parsedChordTransposer.transpose(chart_key, transpose_to, orig_parsed);

  const beatWidth =
    scalePercent != null
      ? scalePercent * (BEAT_WIDTHS.max - BEAT_WIDTHS.min) + BEAT_WIDTHS.min
      : undefined;

  const chordDisplay = () => (
    <>
      <span className="chord">{chord_parsed.chord_root}</span>
      <span className="chord-accidental">{chord_parsed.accidental}</span>
      <span className="chord-flavor">{chord_parsed.flavor}</span>

      {chord_parsed.base_note_raw && (
        <span className="chord-base-note">
          <span className="bar">/</span>
          {chord_parsed.base_note_raw}
        </span>
      )}

      {chord_parsed.alt_chord_raw && (
        <span className="chord-alt">
          <ChordComponent
            transpose_to={transpose_to}
            chart_key={chart_key}
            beat_text={chord_parsed.alt_chord_raw}
          />
        </span>
      )}
    </>
  );

  const nonChordDisplay = () => (
    <span className="chord">
      <span className="non-chord">
        {orig_parsed.type === "non_chord" && orig_parsed.non_chord !== "." ? (
          orig_parsed.non_chord
        ) : (
          <span>&nbsp;</span>
        )}
      </span>
    </span>
  );

  return (
    <span className="beat" style={beatWidth != null ? { width: `${beatWidth}px` } : undefined}>
      <span className="chord-container">
        {orig_parsed.chord_root ? chordDisplay() : nonChordDisplay()}
      </span>
    </span>
  );
}

export default React.memo(ChordComponent, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));

